/**
 * Malicke Case  -  content for /services and /listings pages.
 * Lives separately from the blog content (which is markdown-driven).
 */

export const services = [
  {
    id: "roofing",
    name: "Roofing",
    short: "Roof treatments for leaks, fungus, and weatherproofing",
    description:
      "We don't do full roof replacements. What we do is treat your existing roof to stop leaks, kill fungus, and add years of life. We apply siliconizer, Lanco, Sure Coat, and plaster coatings depending on what your roof needs. We also apply Sure Coat to exterior walls for decorative finishes and designs, and inside as well. Treatments cost a fraction of a re-roof and often last just as long.",
    bullets: ["Siliconizer coatings", "Lanco treatments", "Sure Coat", "Plaster finishes", "Wall designs"],
    image: "https://sfile.chatglm.cn/images-ppt/962420755dcb.jpg",
  },
  {
    id: "painting",
    name: "Painting",
    short: "Interior and exterior painting built for the Jamaican climate",
    description:
      "We use moisture and UV rated paints formulated for tropical climates. Proper prep is non-negotiable: scrape, sand, prime, caulk. That's why our paint jobs don't peel after the first rainy season. Interior or exterior, residential or commercial. We cover the furniture, mask the trim, and leave the site clean.",
    bullets: ["Interior + exterior", "Surface prep", "Pressure washing", "Stucco + masonry"],
    image: "https://sfile.chatglm.cn/images-ppt/325a8a95b929.jpg",
  },
  {
    id: "plumbing",
    name: "Plumbing",
    short: "From a leaky faucet to a full-house re-pipe",
    description:
      "We replace old galvanized pipe with PEX and PVC, install solar and electric water heaters, fix leaks, and install new fixtures. Every plumbing job is pressure-tested before we close up the walls. We also install rainwater catchment and backup tank systems. That's a sample, not the full list. If you have something else in mind, contact us and we'll let you know if we can handle it.",
    bullets: ["Re-pipes (PEX + PVC)", "Water heater install", "Leak repair", "Tank + catchment"],
    image: "https://sfile.chatglm.cn/images-ppt/e19ed23d1bc1.jpg",
  },
  {
    id: "renovation",
    name: "Full Renovation",
    short: "Whole-home renovations: design, demo, build, finish",
    description:
      "We take a property from tired to turn-key. Our team handles demo, framing, electrical, plumbing, drywall, paint, cabinetry, and finish work. One crew, one point of contact. We can work in occupied homes with proper dust containment, or on investment properties where the unit is empty.",
    bullets: ["Whole-home reno", "Kitchen + bath", "Design + build", "Project management"],
    image: "https://sfile.chatglm.cn/images-ppt/b0d8b13ea755.jpeg",
  },
];

export const projects = [
  {
    id: "proj-1",
    title: "Browns Town Roof Treatment",
    category: "Roofing",
    duration: "2 days",
    location: "Browns Town, St. Ann",
    description:
      "Applied a siliconizer coating to a leaking concrete roof that had started growing fungus. Cleaned, prepped, and treated the whole surface. Stopped the leak and the roof still looks new two rainy seasons later.",
    image: "https://sfile.chatglm.cn/images-ppt/962420755dcb.jpg",
  },
  {
    id: "proj-2",
    title: "Ocho Rios Townhouse Full Reno",
    category: "Full Renovation",
    duration: "11 weeks",
    location: "Ocho Rios, St. Ann",
    description:
      "Gutted a 1970s townhouse to the block walls and rebuilt it. New roof, new plumbing, new electrical, modern kitchen, frameless glass shower, fresh paint inside and out. Leased to a long-term tenant within a week of going on the market.",
    image: "https://sfile.chatglm.cn/images-ppt/b0d8b13ea755.jpeg",
  },
  {
    id: "proj-3",
    title: "Discovery Bay Cottage Repaint",
    category: "Painting",
    duration: "1 week",
    location: "Discovery Bay, St. Ann",
    description:
      "Pressure-washed, scraped, primed, and repainted a hillside cottage inside and out. Used a UV-rated acrylic in a colour that complements the surrounding greenery. The owner said the neighbours asked for our card the same week.",
    image: "https://sfile.chatglm.cn/images-ppt/325a8a95b929.jpg",
  },
  {
    id: "proj-4",
    title: "St. Ann's Bay Bathroom Remodel",
    category: "Bathroom",
    duration: "4 weeks",
    location: "St. Ann's Bay, St. Ann",
    description:
      "Replaced a dated 1980s bathroom with a walk-in glass shower, floating vanity, modern tile, and all-new copper plumbing. Upgraded the water supply with a 200-gallon backup tank while we were at it.",
    image: "https://sfile.chatglm.cn/images-ppt/5c1e34c95ed9.webp",
  },
];

export const testimonials = [
  {
    id: "t1",
    name: "Marcus Walters",
    role: "Homeowner, Runaway Bay",
    service: "Roofing",
    quote:
      "After two rainy seasons and three patches that never held, the Malicke Case crew came in and treated the roof properly. They photographed every step. I finally know what's over my head. Two seasons later, not a single leak.",
    avatar: "https://sfile.chatglm.cn/images-ppt/f43ddf89a449.jpg",
  },
  {
    id: "t2",
    name: "Tanya Reid",
    role: "Landlord, Ocho Rios",
    service: "Full Renovation",
    quote:
      "They gutted my townhouse to the block walls and rebuilt it in eleven weeks. On budget, on schedule, and the unit was leased within a week of going on the market. I've already booked them for my second property.",
    avatar: "https://sfile.chatglm.cn/images-ppt/679649bf716d.png",
  },
  {
    id: "t3",
    name: "David Clarke",
    role: "Homeowner, Discovery Bay",
    service: "Painting + Plumbing",
    quote:
      "The crew repainted the entire exterior and replaced every old galvanized pipe in the same visit. No drama, no surprises, no hidden costs. They even cleaned the gutters before they left.",
    avatar: "https://sfile.chatglm.cn/images-ppt/13f4324489fa.jpg",
  },
  {
    id: "t4",
    name: "Sharon Brown",
    role: "Property Investor, St. Ann's Bay",
    service: "Renovation + Listing",
    quote:
      "I bought a tired 1960s house in St. Ann's Bay, the Malicke Case team renovated it, and now it's on their listings page for free. One team for the whole project, that's rare in Jamaica. I'll be using them again.",
    avatar: "https://sfile.chatglm.cn/images-ppt/f43ddf89a449.jpg",
  },
];

export const faqs = [
  {
    q: "What areas do you cover?",
    a: "We're based in Browns Town, St. Ann, and most of our work is in and around the parish. We also travel for jobs across the island, and our listings include properties in Kingston and St. Andrew for university students. If you're not sure whether we cover your area, just call.",
  },
  {
    q: "What's the difference between an estimation and a quotation?",
    a: "An estimation is free and done over the phone from your description, photos, or video. No site visit. Because we can't see everything, the estimation includes a small markup as headroom for surprises. If you're honest about the condition and we don't hit surprises, that markup gets refunded, usually quickly. A quotation is paid and includes a face-to-face site visit. It's closer to an exact number because we've actually inspected the job.",
  },
  {
    q: "How do materials work?",
    a: "You have two options. Option one: we give you a list of what we need, you source it and have it on site before we start. Option two: we handle all the sourcing and you pick up the bill. Most people go with option two for convenience, but option one lets you shop around for the best price.",
  },
  {
    q: "How long does a typical project take?",
    a: "A roof treatment takes 1 to 3 days depending on size. Interior or exterior paint takes 1 to 2 weeks. A full renovation takes 8 to 16 weeks. We give you a real schedule in writing before we start, and we stick to it.",
  },
  {
    q: "Can I stay in my home during the work?",
    a: "For paint and minor plumbing, yes. We contain dust and clean daily. For full renovations we recommend moving out for the demo and rough-in phases. We'll talk you through what to expect before you sign.",
  },
  {
    q: "Do you handle permits?",
    a: "For most residential work in Jamaica, permits aren't required unless you're doing major work that interferes with roads or public property. We don't take on those kinds of jobs. If your project does need a permit for some reason, we'll let you know up front.",
  },
  {
    q: "How do payments work?",
    a: "We work in milestones: a deposit to secure the schedule, then progress payments tied to specific deliverables (roof treated, plumbing rough-in, paint complete, etc.). Final payment is due only when you sign off on the punch list.",
  },
  {
    q: "Do you offer a warranty?",
    a: "We don't have a formal written warranty, but here's our promise: if something we did fails later and there's probable cause, we'll come back and redo the work properly. That hardly ever happens, but the promise stands.",
  },
  {
    q: "Do you also list properties for rent or sale?",
    a: "Yes. If you hire us to renovate your property, we can list it on our /listings page for free when it's done. We also list properties from owners who haven't used our repair services. Listing is free while we're building traffic.",
  },
  {
    q: "Can I list my property for free even if you didn't renovate it?",
    a: "Yes. We list properties from owners across the island for free. You keep all the rent, we handle the listing, the map, and the inquiries. Free while we're building traffic. There may be a paid tier later with premium placement, but for now it's free.",
  },
];

export const processSteps = [
  {
    no: "01",
    title: "Phone estimation",
    body: "Call us and describe the job. We send a free written estimation with line items and a real schedule, usually within 72 hours. If you want a firm on-site quotation instead, that's a paid site visit, but it's closer to an exact number.",
  },
  {
    no: "02",
    title: "Scheduling & materials",
    body: "Once you sign, we lock in your start date. For materials you have two options: source what you need from our list and have it on site before we start, or let us handle sourcing and you pick up the bill. You get a project lead who is your single point of contact from day one.",
  },
  {
    no: "03",
    title: "Build & daily clean-up",
    body: "Our crew shows up on the days we promise. We contain dust, clean the site daily, and photograph every layer of work, especially the stuff that gets covered up.",
  },
  {
    no: "04",
    title: "Walk-through",
    body: "We do a final walk-through with you and fix anything on the punch list. If something we did fails later and there's probable cause, we'll come back and redo it properly. That hardly ever happens, but the promise stands.",
  },
];

export const stats = [
  { value: "Free", label: "Written estimations" },
  { value: "Free", label: "List your property" },
  { value: "1 crew", label: "Repairs to listings" },
  { value: "72 hrs", label: "Estimation turnaround" },
];

export const listingsStats = [
  { value: "9+", label: "Active listings" },
  { value: "Free", label: "For property owners" },
  { value: "2", label: "Parishes covered" },
  { value: "Students", label: "UWI & UTECH welcome" },
];

export const listingAmenities = [
  {
    title: "Free to list",
    body: "Owners list for free while we build traffic. You keep all the rent, we handle the listing, map, and inquiries.",
  },
  {
    title: "Student-friendly",
    body: "We list rooms and apartments near UWI Mona and UTECH. Students and young professionals welcome.",
  },
  {
    title: "Interactive map on every listing",
    body: "Every property gets an interactive map with a driving route from the nearest airport and step-by-step directions to the gate.",
  },
  {
    title: "St. Ann and Kingston",
    body: "Listings span St. Ann (our base) and Kingston/St. Andrew (student rentals). More areas as we grow.",
  },
  {
    title: "We don't handle paperwork",
    body: "We host the listing and remove it when it's gone. You handle the lease, the keys, and the rent. Simple.",
  },
  {
    title: "Future paid tier",
    body: "There may be a paid tier later with premium placement. For now, all listings are free and equal.",
  },
];

// === Properties ===
export const properties = [
  {
    id: "p1",
    name: "Runaway Bay Ocean Villa",
    tagline: "Beachfront villa, fully renovated by our crew",
    description:
      "Four-bedroom beachfront villa with a clear view of the Caribbean Sea from the back deck. We stripped the old roof off and put down new underlayment and standing-seam metal, repainted every room inside and out, and ran all-new PEX and PVC plumbing through the walls. Vaulted native-wood ceilings, an open-plan kitchen, and a private path down to the beach. Available for long-term lease. Good fit for a family or someone working remote who wants the sea out the window.",
    status: "For Lease",
    type: "Villa",
    price: "JMD $3,800",
    pricePeriod: "/ month",
    beds: 4,
    baths: 3,
    sqft: 3200,
    location: "Runaway Bay, St. Ann",
    parish: "St. Ann",
    coordinates: { lat: 18.4584, lng: -77.3261 },
    heroImage: "https://sfile.chatglm.cn/images-ppt/674855aaa5fd.jpg",
    gallery: [
      "https://sfile.chatglm.cn/images-ppt/674855aaa5fd.jpg",
      "https://sfile.chatglm.cn/images-ppt/2fb573351848.jpg",
      "https://sfile.chatglm.cn/images-ppt/8140048f3563.jpeg",
      "https://sfile.chatglm.cn/images-ppt/4f75a647dda6.jpg",
    ],
    amenities: [
      "Beachfront access",
      "Air conditioning",
      "Solar water heater",
      "Backup water tank",
      "Fibre internet",
      "Covered parking",
      "Outdoor shower",
      "Security grill",
    ],
    features: [
      "New roof (2025)",
      "Fresh interior + exterior paint",
      "All-new copper plumbing",
      "Hurricane-rated impact windows",
      "Open-plan chef's kitchen",
      "Wraparound deck",
    ],
    crewRenovated: true,
    student: false,
    drivingFrom: {
      label: "Sangster Int'l Airport (MBJ), Montego Bay",
      coordinates: { lat: 18.5037, lng: -77.9134 },
    },
    estDriveTime: "1h 5m",
    estDistance: "67 km",
    directions: [
      { step: "Exit Sangster Int'l Airport onto the A1 highway eastbound toward Falmouth.", distance: "0 km" },
      { step: "Continue east on the A1 (North Coast Highway) through Falmouth and Duncans.", distance: "32 km" },
      { step: "Pass through Rio Bueno bridge and stay on the A1 toward St. Ann's Bay.", distance: "18 km" },
      { step: "Continue past Discovery Bay. The road climbs then drops into Runaway Bay.", distance: "11 km" },
      { step: "Turn right at the Runaway Bay traffic light onto Salem Road, toward the sea.", distance: "4 km" },
      { step: "Go 1.2 km to the beachfront gate. Villa is on the right with the coral sign.", distance: "1.2 km" },
    ],
  },
  {
    id: "p2",
    name: "Discovery Bay Hillside Cottage",
    tagline: "Hillside cottage with a view of the bay",
    description:
      "Two-bedroom cottage perched above Discovery Bay. We went top to bottom: new metal-shingle roof, replumbed the kitchen and bath, and repainted the whole exterior in a colour that stands out against the green hillside. Comes furnished with locally made Jamaican pieces. Quiet, secure, good for a couple or a small family who wants a view with their morning coffee.",
    status: "For Rent",
    type: "Cottage",
    price: "JMD $1,950",
    pricePeriod: "/ month",
    beds: 2,
    baths: 2,
    sqft: 1450,
    location: "Discovery Bay, St. Ann",
    parish: "St. Ann",
    coordinates: { lat: 18.4654, lng: -77.3958 },
    heroImage: "https://sfile.chatglm.cn/images-ppt/8140048f3563.jpeg",
    gallery: [
      "https://sfile.chatglm.cn/images-ppt/8140048f3563.jpeg",
      "https://sfile.chatglm.cn/images-ppt/1b875b7357c2.jpg",
      "https://sfile.chatglm.cn/images-ppt/c44f33ecd7f9.jpg",
      "https://sfile.chatglm.cn/images-ppt/674855aaa5fd.jpg",
    ],
    amenities: [
      "Hillside ocean view",
      "Air conditioning",
      "Solar water heater",
      "Backup water tank",
      "High-speed internet",
      "Covered parking",
      "Landscaped garden",
    ],
    features: [
      "New metal-shingle roof",
      "Fresh exterior + interior paint",
      "Replumbed kitchen + bath",
      "New kitchen cabinetry",
      "Private balcony off primary bedroom",
      "Generator hookup",
    ],
    crewRenovated: true,
    student: false,
    drivingFrom: {
      label: "Sangster Int'l Airport (MBJ), Montego Bay",
      coordinates: { lat: 18.5037, lng: -77.9134 },
    },
    estDriveTime: "55m",
    estDistance: "55 km",
    directions: [
      { step: "Exit Sangster Int'l Airport onto the A1 highway eastbound toward Falmouth.", distance: "0 km" },
      { step: "Continue on A1 through Falmouth, Duncans, and Rio Bueno.", distance: "44 km" },
      { step: "Just past the Rio Bueno bridge, climb the hill toward Discovery Bay.", distance: "8 km" },
      { step: "Turn left onto Puerto Bueno Road at the Discovery Bay gas station.", distance: "1.5 km" },
      { step: "Climb 900 m up the hillside. Cottage gate is on the left, marked by a coral-painted wall.", distance: "0.9 km" },
    ],
  },
  {
    id: "p3",
    name: "Ocho Rios Palms",
    tagline: "Modern townhouse, five minutes from Ochi town centre",
    description:
      "Three-bedroom townhouse five minutes from Ocho Rios and Dunn's River Falls. We stripped this one to the studs and rebuilt it: new roof trusses, full repaint, all-new PVC plumbing, modern kitchen and bath. Gated complex with pool, 24/7 security, and standby power. Available for annual lease.",
    status: "For Lease",
    type: "Townhouse",
    price: "JMD $2,400",
    pricePeriod: "/ month",
    beds: 3,
    baths: 2,
    sqft: 1850,
    location: "Ocho Rios, St. Ann",
    parish: "St. Ann",
    coordinates: { lat: 18.4017, lng: -77.0986 },
    heroImage: "https://sfile.chatglm.cn/images-ppt/c44f33ecd7f9.jpg",
    gallery: [
      "https://sfile.chatglm.cn/images-ppt/c44f33ecd7f9.jpg",
      "https://sfile.chatglm.cn/images-ppt/1b875b7357c2.jpg",
      "https://sfile.chatglm.cn/images-ppt/79a73aa38e1d.jpg",
      "https://sfile.chatglm.cn/images-ppt/8140048f3563.jpeg",
    ],
    amenities: [
      "Shared pool",
      "24/7 security",
      "Standby generator",
      "Air conditioning",
      "Solar water heater",
      "Fibre internet",
      "Covered parking",
      "Gated complex",
    ],
    features: [
      "New roof trusses + sheathing",
      "Full interior repaint",
      "All-new PVC plumbing",
      "Quartz kitchen counters",
      "Frameless glass shower",
      "Smart locks",
    ],
    crewRenovated: true,
    student: false,
    drivingFrom: {
      label: "Sangster Int'l Airport (MBJ), Montego Bay",
      coordinates: { lat: 18.5037, lng: -77.9134 },
    },
    estDriveTime: "1h 35m",
    estDistance: "105 km",
    directions: [
      { step: "Exit Sangster Int'l Airport onto the A1 eastbound.", distance: "0 km" },
      { step: "Continue through Falmouth, Duncans, Rio Bueno, Discovery Bay, and Runaway Bay.", distance: "62 km" },
      { step: "Pass St. Ann's Bay and continue east on A1 into Ocho Rios.", distance: "30 km" },
      { step: "Turn right at the Main Street traffic light onto Milford Road.", distance: "1.2 km" },
      { step: "Go 800 m up Milford Road. Gated complex is on the right.", distance: "0.8 km" },
    ],
  },
  {
    id: "p4",
    name: "Browns Town Garden Cottage",
    tagline: "Quiet inland living with a half-acre garden",
    description:
      "One-bedroom cottage on the inland side of Browns Town. Good for a single professional or a couple. We repaired the roof, repainted inside and out, and replaced all the old galvanized plumbing with PVC. Half-acre lot with established fruit trees: mango, ackee, and breadfruit. Cool mountain breeze year-round.",
    status: "For Rent",
    type: "Cottage",
    price: "JMD $950",
    pricePeriod: "/ month",
    beds: 1,
    baths: 1,
    sqft: 750,
    location: "Browns Town, St. Ann",
    parish: "St. Ann",
    coordinates: { lat: 18.3996, lng: -77.3479 },
    heroImage: "https://sfile.chatglm.cn/images-ppt/e3aadaa66911.jpg",
    gallery: [
      "https://sfile.chatglm.cn/images-ppt/e3aadaa66911.jpg",
      "https://sfile.chatglm.cn/images-ppt/1b875b7357c2.jpg",
      "https://sfile.chatglm.cn/images-ppt/674855aaa5fd.jpg",
    ],
    amenities: [
      "Half-acre lot",
      "Fruit trees (mango, ackee, breadfruit)",
      "Air conditioning",
      "Solar water heater",
      "Backup water tank",
      "Covered parking",
      "Garden space",
    ],
    features: [
      "Roof repair + new flashing",
      "Full exterior + interior paint",
      "All-new PVC plumbing",
      "New kitchenette",
      "Refinished hardwood floors",
      "Rainwater catchment",
    ],
    crewRenovated: true,
    student: false,
    drivingFrom: {
      label: "Sangster Int'l Airport (MBJ), Montego Bay",
      coordinates: { lat: 18.5037, lng: -77.9134 },
    },
    estDriveTime: "1h 5m",
    estDistance: "62 km",
    directions: [
      { step: "Exit Sangster Int'l Airport onto the A1 eastbound.", distance: "0 km" },
      { step: "Continue on A1 through Falmouth and Duncans.", distance: "32 km" },
      { step: "Turn right onto the B3 (Browns Town main road) just before Rio Bueno.", distance: "16 km" },
      { step: "Continue uphill into Browns Town centre.", distance: "12 km" },
      { step: "Turn left onto Gibraltar Road just past the Browns Town market.", distance: "1.1 km" },
      { step: "Go 700 m. Cottage gate is on the right with a coral mailbox.", distance: "0.7 km" },
    ],
  },
  {
    id: "p5",
    name: "St. Ann's Bay Heritage House",
    tagline: "Restored 1960s Jamaican home in the parish capital",
    description:
      "Restored 1960s Jamaican home in St. Ann's Bay. We kept the original mahogany floors and sash windows, then put on a new roof, repainted everything, and ran modern plumbing. Walk to the courthouse, the market, and the beach. Three bedrooms, two baths, and a deep verandah that catches the trade winds all afternoon.",
    status: "For Sale",
    type: "House",
    price: "JMD $285,000",
    beds: 3,
    baths: 2,
    sqft: 2100,
    location: "St. Ann's Bay, St. Ann",
    parish: "St. Ann",
    coordinates: { lat: 18.4042, lng: -77.0344 },
    heroImage: "https://sfile.chatglm.cn/images-ppt/1b875b7357c2.jpg",
    gallery: [
      "https://sfile.chatglm.cn/images-ppt/1b875b7357c2.jpg",
      "https://sfile.chatglm.cn/images-ppt/c44f33ecd7f9.jpg",
      "https://sfile.chatglm.cn/images-ppt/79a73aa38e1d.jpg",
      "https://sfile.chatglm.cn/images-ppt/8140048f3563.jpeg",
    ],
    amenities: [
      "Deep verandah",
      "Original mahogany floors",
      "Air conditioning",
      "Solar water heater",
      "Backup water tank",
      "Off-street parking",
      "Mature shade trees",
    ],
    features: [
      "New roof with original eave detail",
      "Full repaint in heritage palette",
      "All-new plumbing (PEX + PVC)",
      "Restored sash windows",
      "Modern kitchen in keeping with era",
      "Rewired electrical",
    ],
    crewRenovated: true,
    student: false,
    drivingFrom: {
      label: "Sangster Int'l Airport (MBJ), Montego Bay",
      coordinates: { lat: 18.5037, lng: -77.9134 },
    },
    estDriveTime: "1h 15m",
    estDistance: "82 km",
    directions: [
      { step: "Exit Sangster Int'l Airport onto the A1 eastbound.", distance: "0 km" },
      { step: "Continue through Falmouth, Duncans, Rio Bueno, Discovery Bay, and Runaway Bay.", distance: "62 km" },
      { step: "Pass the St. Ann's Bay traffic light; continue 1 km into town.", distance: "1 km" },
      { step: "Turn right onto Main Street just past the courthouse.", distance: "0.4 km" },
      { step: "Go 600 m. House is on the left with a coral front door.", distance: "0.6 km" },
    ],
  },
  {
    id: "p6",
    name: "Falmouth Coastal Modern",
    tagline: "New build, never lived in",
    description:
      "Brand-new build we finished in early 2026, just outside historic Falmouth. Three bedrooms, two baths, modern kitchen, new roof with deep overhangs for shade, and all-new plumbing and electrical. Designed for cross-ventilation and natural light. Walk to the Falmouth pier and the Georgian town centre.",
    status: "For Sale",
    type: "House",
    price: "JMD $340,000",
    beds: 3,
    baths: 2,
    sqft: 1950,
    location: "Falmouth, Trelawny",
    parish: "Trelawny",
    coordinates: { lat: 18.4912, lng: -77.6589 },
    heroImage: "https://sfile.chatglm.cn/images-ppt/79a73aa38e1d.jpg",
    gallery: [
      "https://sfile.chatglm.cn/images-ppt/79a73aa38e1d.jpg",
      "https://sfile.chatglm.cn/images-ppt/c44f33ecd7f9.jpg",
      "https://sfile.chatglm.cn/images-ppt/8140048f3563.jpeg",
      "https://sfile.chatglm.cn/images-ppt/674855aaa5fd.jpg",
    ],
    amenities: [
      "Brand new construction",
      "Deep overhang roof",
      "Air conditioning",
      "Solar water heater",
      "Backup water tank",
      "Covered parking",
      "Landscaped yard",
    ],
    features: [
      "New hurricane-rated roof",
      "Fresh paint throughout",
      "All-new plumbing + electrical",
      "Quartz kitchen counters",
      "Energy-efficient windows",
      "Smart home pre-wire",
    ],
    crewRenovated: true,
    student: false,
    drivingFrom: {
      label: "Sangster Int'l Airport (MBJ), Montego Bay",
      coordinates: { lat: 18.5037, lng: -77.9134 },
    },
    estDriveTime: "35m",
    estDistance: "30 km",
    directions: [
      { step: "Exit Sangster Int'l Airport onto the A1 eastbound toward Falmouth.", distance: "0 km" },
      { step: "Continue 22 km on the A1. Pass Greenwood and Trelawny Beach.", distance: "22 km" },
      { step: "Take the Falmouth bypass exit and continue toward the town centre.", distance: "5 km" },
      { step: "Turn right onto Thorpe Road just past the Falmouth pier.", distance: "1.5 km" },
      { step: "Go 1.2 km. House is on the left with a coral accent wall.", distance: "1.2 km" },
    ],
  },
  // === Owner-listed properties (free listings, not crew-renovated) ===
  {
    id: "p7",
    name: "Mona Studio near UWI",
    tagline: "Walk to campus, owner-listed",
    description:
      "Compact studio apartment in Mona, a 5-minute walk to the UWI Mona campus. Listed free by the owner, not renovated by our crew. Single room with kitchenette, bathroom, and a small study area. Good for a first-year student who wants to be close to lectures. Utilities included.",
    status: "For Rent",
    type: "Apartment",
    price: "JMD $850",
    pricePeriod: "/ month",
    beds: 1,
    baths: 1,
    sqft: 550,
    location: "Mona, Kingston",
    parish: "St. Andrew",
    coordinates: { lat: 18.0059, lng: -76.7468 },
    heroImage: "https://sfile.chatglm.cn/images-ppt/1b875b7357c2.jpg",
    gallery: [
      "https://sfile.chatglm.cn/images-ppt/1b875b7357c2.jpg",
      "https://sfile.chatglm.cn/images-ppt/c44f33ecd7f9.jpg",
      "https://sfile.chatglm.cn/images-ppt/79a73aa38e1d.jpg",
    ],
    amenities: [
      "Walk to UWI campus",
      "Utilities included",
      "Furnished",
      "Wi-Fi ready",
      "On bus route",
      "Laundry shared",
    ],
    features: [
      "Owner-listed, not crew-renovated",
      "Kitchenette",
      "Study area",
      "Shared garden",
    ],
    crewRenovated: false,
    student: true,
    drivingFrom: {
      label: "Norman Manley Int'l Airport (KIN), Kingston",
      coordinates: { lat: 17.9357, lng: -76.7875 },
    },
    estDriveTime: "35m",
    estDistance: "22 km",
    directions: [
      { step: "Exit Norman Manley Airport onto the Palisadoes Road toward downtown Kingston.", distance: "0 km" },
      { step: "Continue on Palisadoos Road, then onto Harbour Street through downtown.", distance: "8 km" },
      { step: "Turn right onto Knutsford Boulevard, then left onto Oxford Road.", distance: "5 km" },
      { step: "Continue onto Old Hope Road through New Kingston.", distance: "4 km" },
      { step: "Turn right onto Mona Road, toward the UWI campus.", distance: "3 km" },
      { step: "Go 1.5 km past the UWI main gate. Studio is on the left, second floor.", distance: "1.5 km" },
    ],
  },
  {
    id: "p8",
    name: "Liguanea 2-Bed near UTECH",
    tagline: "Two-bedroom walk to UTECH, owner-listed",
    description:
      "Two-bedroom apartment in Liguanea, walking distance to UTECH and a short ride to UWI. Listed free by the owner, not renovated by our crew. Good for two students sharing or a young professional. Living room, kitchen, bathroom, and a small balcony. Close to Liguanea shopping and food.",
    status: "For Rent",
    type: "Apartment",
    price: "JMD $1,400",
    pricePeriod: "/ month",
    beds: 2,
    baths: 1,
    sqft: 1100,
    location: "Liguanea, Kingston",
    parish: "St. Andrew",
    coordinates: { lat: 18.0150, lng: -76.7650 },
    heroImage: "https://sfile.chatglm.cn/images-ppt/79a73aa38e1d.jpg",
    gallery: [
      "https://sfile.chatglm.cn/images-ppt/79a73aa38e1d.jpg",
      "https://sfile.chatglm.cn/images-ppt/1b875b7357c2.jpg",
      "https://sfile.chatglm.cn/images-ppt/c44f33ecd7f9.jpg",
    ],
    amenities: [
      "Walk to UTECH",
      "Short ride to UWI",
      "Furnished",
      "Wi-Fi ready",
      "On bus route",
      "Parking for 1 car",
      "Balcony",
    ],
    features: [
      "Owner-listed, not crew-renovated",
      "Living room + kitchen",
      "Shared bathroom",
      "Storage closet",
    ],
    crewRenovated: false,
    student: true,
    drivingFrom: {
      label: "Norman Manley Int'l Airport (KIN), Kingston",
      coordinates: { lat: 17.9357, lng: -76.7875 },
    },
    estDriveTime: "40m",
    estDistance: "25 km",
    directions: [
      { step: "Exit Norman Manley Airport onto the Palisadoes Road toward downtown.", distance: "0 km" },
      { step: "Continue through downtown onto Harbour Street, then Knutsford Boulevard.", distance: "8 km" },
      { step: "Turn left onto Old Hope Road through New Kingston.", distance: "6 km" },
      { step: "Continue on Old Hope Road past UTECH.", distance: "8 km" },
      { step: "Turn right onto Liguanea Avenue just past the Liguanea Post Office.", distance: "2 km" },
      { step: "Go 800 m. Apartment complex is on the right, gate code provided on booking.", distance: "0.8 km" },
    ],
  },
  {
    id: "p9",
    name: "New Kingston 1-Bedroom",
    tagline: "Central New Kingston, owner-listed",
    description:
      "One-bedroom apartment in the heart of New Kingston, walking distance to offices, restaurants, and nightlife. Listed free by the owner, not renovated by our crew. Good for a young professional or a postgrad student. Building has 24-hour security, elevator, and covered parking.",
    status: "For Rent",
    type: "Apartment",
    price: "JMD $1,100",
    pricePeriod: "/ month",
    beds: 1,
    baths: 1,
    sqft: 700,
    location: "New Kingston, Kingston",
    parish: "Kingston",
    coordinates: { lat: 18.0089, lng: -76.7842 },
    heroImage: "https://sfile.chatglm.cn/images-ppt/c44f33ecd7f9.jpg",
    gallery: [
      "https://sfile.chatglm.cn/images-ppt/c44f33ecd7f9.jpg",
      "https://sfile.chatglm.cn/images-ppt/79a73aa38e1d.jpg",
      "https://sfile.chatglm.cn/images-ppt/1b875b7357c2.jpg",
    ],
    amenities: [
      "24-hour security",
      "Elevator",
      "Covered parking",
      "Walk to offices",
      "Walk to restaurants",
      "Wi-Fi ready",
      "Furnished",
    ],
    features: [
      "Owner-listed, not crew-renovated",
      "Open-plan living",
      "Kitchen with appliances",
      "Balcony with city view",
    ],
    crewRenovated: false,
    student: true,
    drivingFrom: {
      label: "Norman Manley Int'l Airport (KIN), Kingston",
      coordinates: { lat: 17.9357, lng: -76.7875 },
    },
    estDriveTime: "30m",
    estDistance: "20 km",
    directions: [
      { step: "Exit Norman Manley Airport onto the Palisadoes Road toward downtown.", distance: "0 km" },
      { step: "Continue through downtown onto Harbour Street.", distance: "8 km" },
      { step: "Turn right onto Knutsford Boulevard into New Kingston.", distance: "3 km" },
      { step: "Continue 600 m. Building is on the left, next to the plaza.", distance: "0.6 km" },
    ],
  },
];
